import React, { SVGProps } from 'react';

export const SurveyRulesSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#clip0_681_57851)'>
      <path
        d='M1.90625 2.84375C1.90625 3.34103 2.10379 3.81794 2.45542 4.16958C2.80706 4.52121 3.28397 4.71875 3.78125 4.71875C4.27853 4.71875 4.75544 4.52121 5.10708 4.16958C5.45871 3.81794 5.65625 3.34103 5.65625 2.84375C5.65625 2.34647 5.45871 1.86956 5.10708 1.51792C4.75544 1.16629 4.27853 0.96875 3.78125 0.96875C3.28397 0.96875 2.80706 1.16629 2.45542 1.51792C2.10379 1.86956 1.90625 2.34647 1.90625 2.84375Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.1875 15.0312L5.65625 10.3438H6.59375V8.46875C6.59375 7.72283 6.29743 7.00746 5.76999 6.48001C5.24254 5.95257 4.52717 5.65625 3.78125 5.65625C3.03533 5.65625 2.31996 5.95257 1.79251 6.48001C1.26507 7.00746 0.96875 7.72283 0.96875 8.46875V10.3438H1.90625L2.375 15.0312H5.1875Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M10.8125 7.53125H8.46875' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M10.8125 1.90625H10.3438C10.0951 1.90625 9.85665 2.00502 9.68084 2.18084C9.50502 2.35665 9.40625 2.59511 9.40625 2.84375V12.2188C9.40625 12.4674 9.50502 12.7058 9.68084 12.8817C9.85665 13.0575 10.0951 13.1563 10.3438 13.1563H10.8125'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.2188 1.90625L13.1563 2.84375L15.0313 0.96875'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.2188 7.53125L13.1563 8.46875L15.0313 6.59375'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M12.2188 12.2188L15.0313 15.0313' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M15.0313 12.2188L12.2188 15.0313' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    </g>
    <defs>
      <clipPath id='clip0_681_57851'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
